import React, { useContext, useState } from 'react';
import Modal from '../modal/Modal';
import { useTranslation } from 'react-i18next';
import { ClosureSvg } from '../../icons';
import { AUTH_EXIT, PAYMENT_EXIT } from '../../common/errorCodes';
import ManualController from '../../hoc/ManualController';
import { IHeaderClosureProps } from '../../interfaces';
import { useNavigate } from 'react-router-dom';
import { MainContext } from '../../context/main.context';
import Transactions from '../transactions';


export default function Closure({ origin, source }: IHeaderClosureProps): JSX.Element | null {
    const { t } = useTranslation();
    const [ showModal, setShowModal ] = useState<boolean>(false);
    const [ isPaymentsOrigin ] = useState<boolean>(Boolean(origin === 'payments'));
    const { manualRedirect } = ManualController();
    const navigate = useNavigate();
    const { modalContent, setModalContent } = useContext(MainContext);

    const _returnToGame = (): void => {
        if (!isPaymentsOrigin) {
            manualRedirect({}, 'auth', true, AUTH_EXIT);
            return;
        }

        manualRedirect({}, 'payment', true, PAYMENT_EXIT);
    }

    const _onSubmit = (key: boolean): void => {
        if (key) {
            if (!isPaymentsOrigin) {
                setShowModal(false);
                return;
            }

            _returnToGame();
            return;
        }

        if (!isPaymentsOrigin) {
            _returnToGame();
            return;
        }

        setShowModal(false);
    }

    const _renderClosureModal = () => {
        return (
            <div className="closure-modal">
                <div className="closure-modal-title">
                    { !isPaymentsOrigin ? t('returnToGame') : t('payment.cancellation') }
                </div>
                <div className="closure-modal-buttons">
                    <button className="closure-modal-button" onClick={() => _onSubmit(true)}>
                        { !isPaymentsOrigin ? t('no') : t('yes') }
                    </button>
                    <button className="closure-modal-button closure-modal-button-color" onClick={() => _onSubmit(false)}>
                        { !isPaymentsOrigin ? t('yes') : t('no') }
                    </button>
                </div>
            </div>
        );
    }

    const _onClosureClick = () => {
        if (origin === 'transactions') {
            if (modalContent) {
                setModalContent(null);
                return;
            }

            navigate('/');
            return;
        }

        if (origin === 'transactionHelper') {
            if (modalContent) {
                setModalContent(null);
                return;
            }

            navigate('/');
            return;
        }

        if (modalContent) {
            setModalContent(null);
            return;
        }

        setShowModal(true);
    }

    return (
        <div className="closure-container" onClick={_onClosureClick}>
            <ClosureSvg/>
            {
                showModal ?
                    <Modal open onClose={() => setShowModal(false)} hideCloseButton>
                        {_renderClosureModal()}
                    </Modal>
                : null
            }
        </div>
    );
}